<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/Master/ProductBrand'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fab fa-product-hunt"></i>
            </span>
            <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
          </div>
        </div>
        <div class="kt-portlet__body">

          <form class="kt-form" @submit="formSubmit">
            <div class="row">

              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    id="pbSearch"
                    name="pbSearch"
                    v-model="pbSearch"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจากชื่อแบรนด์"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pbInActiveStatus'"
                    :name="'pbInActiveStatus'"
                    :select2-options="pbInActiveStatusOptions"
                    v-model="pbInActiveStatus"
                    ref="pbInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>กลุ่มแบรนด์ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pbRivalStatus'"
                    :name="'pbRivalStatus'"
                    :select2-options="pbRivalStatusOptions"
                    v-model="pbRivalStatus"
                    ref="pbRivalStatusSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ (การทำ PM):</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pbPMStatus'"
                    :name="'pbPMStatus'"
                    :select2-options="pbPMStatusOptions"
                    v-model="pbPMStatus"
                    ref="pbPMStatusSelect2"
                  ></select2>
                </div>
              </div>

            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button type="reset" class="btn btn-secondary" @click="formReset">ล้างค่าทั้งหมด</button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="ProductBrand/Add"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER', 'MANAGE_APPROVER'])"
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มแบรนด์
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="productBrandTable"
              >
                <thead>
                  <tr>
                    <th class="all">ชื่อแบรนด์</th>
                    <th class="all">กลุ่ม</th>
                    <th class="all">สถานะ</th>
                    <th class="all">สถานะ (การทำ PM)</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
let RivalActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" v-if="data.showEditStatusButton"  class="btn btn-sm btn-danger disabled">
      <i class="fab fa-product-hunt"></i>แบรนด์คู่แข่ง
    </a>
  </div>`
});

let RivalActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="" v-if="data.showEditStatusButton"  class="btn btn-sm btn-success disabled">
      <i class="fab fa-product-hunt"></i>แบรนด์ในเครือ
    </a>
  </div>`
});
let PMStatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="" @click.prevent="editPMStatus" v-if="data.showEditPMStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editPMStatus: function() {
      let self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะการทำ PM",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะการทำ PM <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะการทำ PM",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/ProductBrand/" + this.data.productBrandId + "/TogglePM")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let PMStatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editPMStatus" v-if="data.showEditPMStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editPMStatus: function() {
      let self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะการทำ PM ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะการทำ PM  <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะการทำ PM ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/ProductBrand/" + this.data.productBrandId + "/TogglePM")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/ProductBrand/" + this.data.productBrandId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/ProductBrand/" + this.data.productBrandId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let productBrandActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editProductBrand" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="deleteProductBrand" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    editProductBrand: function() {
      router.push({
        path: `/Master/ProductBrand/Edit/${this.data.productBrandId}`
      });
    },
    deleteProductBrand: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลแบรนด์",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลแบรนด์",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder:
          "ต้องการลบข้อมูลแบรนด์",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          axios
            .put("/Api/ProductBrand/" + this.data.productBrandId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
export default {
  components: {
    select2
  },
  data: function() {
    var self = this;

    return {
      pbSearch: null,

      pbInActiveStatus: null,
      pbRivalStatus : null,
      pbPMStatus : null,

      pbInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null }
        ]
      },
      pbRivalStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "แบรนด์ในเครือ", data: null },
          { id: "true", text: "แบรนด์คู่แข่ง", data: null }
        ]
      },
      pbPMStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "true", text: "ใช้งาน", data: null },
          { id: "false", text: "ปิดใช้งาน", data: null }
        ]
      },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.pbSearch = null;

      this.pbInActiveStatus = null;
      $("#pbInActiveStatus")
        .val(this.pbInActiveStatus + "")
        .trigger("change");

      this.pbPMStatus = null;
      $("#pbPMStatus")
        .val(this.pbPMStatus + "")
        .trigger("change");

    this.pbRivalStatus = null;
      $("#pbRivalStatus")
        .val(this.pbRivalStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
 
     

    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#productBrandTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#productBrandTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    }
  },
  async mounted() {
    let self = this;

    $(`#pbInActiveStatus`).val("false").trigger('change');

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#productBrandTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/ProductBrand/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.pbSearch,
                InActiveStatus: self.pbInActiveStatus,
                RivalBrand : self.pbRivalStatus,
                PmBrand : self.pbPMStatus
              })
            );
          }
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_"
        },

        // Order settings
        order: [[0, "asc"]],
        columns: [
          {
            data: "productBrandName",
            width: "20%",
            className: "text-center"
          },
          {
            data: "rivalBrand",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsRival"></div>';
            }
          },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            }
          },
          {
            data: "pmBrand",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsPMStatus"></div>';
            }
          },
           {
            data: "productBrandId",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            }
          }
        ]
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actionsPMStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditPMStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
            if (data.pmBrand == 1)
              new PMStatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.pmBrand ==null || data.pmBrand == 0)
              new PMStatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
         $(".actionsRival").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
            if (data.rivalBrand == 0)
              new RivalActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.rivalBrand == 1)
              new RivalActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
            data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
            new productBrandActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/ProductBrand/ProductBrandList.vue